import { FieldHolder } from "@/components/holders/FieldHolder";
import { useModel } from "@/models/base/useModel";
import React, { Component,useImperativeHandle,useRef,useState } from "react";
import { v4 as uuid } from "uuid";
import KdmEditor from "../base/editor/KdmEditor";


export function CurrentJobPanel({...props}) {
    const {tm, registerField} = useModel('name', props?.data);

    return (
    <>

    <div className="px-4 pb-4 sm:px-6 lg:px-8 space-y-10 divide-y divide-gray-900/10">
      <div className="grid grid-cols-1 gap-x-1 gap-y-1 md:grid-cols-1">

        <h5>Huidige werk situatie</h5>


                <div className="grid grid-cols-12 gap-3">
              <FieldHolder colspan="12" smcolspan="3" label="Functie" id="function" error={props?.state?.error}>
                  <input
                    {...registerField('jobexperience.function')}
//                    key={(props.data && props.data.address[addressIndex].zipcode) ?? null}
  //                  autoComplete="postal-code"

                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </FieldHolder>
              <FieldHolder colspan="12" smcolspan="9" label="Bedrijfsnaam" id="Bedrijfsnaam" error={props?.state?.error}>
                  <input
                    {...registerField('jobexperience.company_name')}
                    autoComplete="address-level2"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
              </FieldHolder>

              </div>
        </div>
        
                <div  className="col-span-12 !mt-2 w-full">
                    <label>Beschrijf hier uw werkzaamheden in uw huidige functie</label>
           <KdmEditor  className="max-h-100 h-96" 
           //onBlur={(event) => {dataObj[lbl] = event.value}}
            {...registerField('jobexperience.description', 'editor')}
            />
                  </div>
        
        </div>
    </>
    )
}    